// Entry point for the build script in your package.json
import * as bootstrap from "bootstrap";

import { Application } from '@hotwired/stimulus'

import { MarksmithController } from '@avo-hq/marksmith'

const application = Application.start()
application.register('clipboard', Clipboard)
application.register('marksmith', MarksmithController)

var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  return new bootstrap.Popover(popoverTriggerEl,{ trigger: 'focus' } )
});

import "@hotwired/turbo-rails"
import "./controllers"

// We don't want turbo doing the click when we are on the same page
document.addEventListener('turbo:click', function(event) {
  if (event.target.getAttribute('href').charAt(0) === '#') {
    return event.preventDefault();
  }
});